import { forwardRef, memo } from 'react'

import { Request } from 'commons/utils/request'
import { ChoiceOption } from 'ui/types'

import { SingleSelectAutoSuggest } from '../SingleSelectAutoSuggest'
import { CompanySelectProps } from './CompanySelectProps'

const PLACEHOLDER = 'Start entering the company name'

export const CompanySelect = memo(
  forwardRef<HTMLDivElement, CompanySelectProps>((props, ref) => {
    const { value, defaultOption, hideMyCompaniesFilter, filters, ...rest } = props

    const options: ChoiceOption[] = rest?.preloadedOptions || []

    if (defaultOption) {
      options.push(defaultOption)
    }

    if (!hideMyCompaniesFilter) {
      options.push({
        label: 'My',
        value: 'my'
      })
    }

    const serverOptions = {
      filters,
      url: Request.urls.bank.companySearch,
      requestSearchString: 'searchString',
      limit: 500,
      mapper: (item) => ({ label: `${item.companyName}`, value: item.id })
    }

    return (
      <SingleSelectAutoSuggest
        noFirstRequest
        placeholder={PLACEHOLDER}
        options={options}
        serverOptions={serverOptions}
        value={value}
        {...rest}
        ref={ref}
      />
    )
  })
)
